// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zs2yL","mainFooter":"styles_mainFooter__vYegl"};